import React, { memo, useEffect, useRef } from 'react';
import { hydrateRoot } from 'react-dom/client';
import { getMMT_HLD_OBJ } from '../../../../common/utils/appUtils';

export const ServerHydrator = ({ component, ...props }) => {
  const Child = component;

  return (
    <section style={{ display: 'flex', maxWidth: '100%' }}>
      <Child {...props} />
    </section>
  );
};

const Hydrator = props => {
  const { component, ...rest } = props;
  const Child = component;
  return (
    <section style={{ display: 'flex', maxWidth: '100%' }}>
      <Child {...rest} />
    </section>
  );
};

export default memo(Hydrator);
